import Tooltip from './tooltip/_Tooltip';
import TooltipHeader from './tooltip/_TooltipHeader';

export { Tooltip, TooltipHeader };



// WEBPACK FOOTER //
// ./app/components/shared/_tooltip.js